import {
  Block,
  BlockComment,
  CommodityMilestone,
  CommodityType,
  CrewMemberAssignment,
  WorkPackage,
  CommodityAssignee,
} from '@bechtel/types';
import { PureQueryOptions, RefetchQueriesFunction } from '@apollo/client';
import { Commodity } from '~/types';

export interface FormikBlockResolutionState {
  resolution: BlockComment['comment'];
}

export interface ResolveBlockProps {
  onClose: () => void;
  workPackageId: WorkPackage['id'];
  workPackageTag: WorkPackage['tag'];
  commodityTag?: Commodity['tag'];
  commodityTypeName?: CommodityType['name'];
  facilities?: WorkPackage['facilities'];
  assignedCrewMembers?: CrewMemberAssignment[];
  weldCommodityAssignees: CommodityAssignee[];
  block?: Block;
  milestone?: CommodityMilestone;
  refetchQueries?: (string | PureQueryOptions)[] | RefetchQueriesFunction;
}
